export class ClassItem {
    id?: number;
    thumbnail_id?: string;
    name: string;
    room: string;
    campus_id: number;
    teacher: string;
    max_number: number;
    suitable_from: string;
    suitable_to: string;
    total_cost: number;
    cost_per_week: any;
    activities: string;
    status: string;
    hol_course: HolCourse;
    prices?: any[];
    constructor() {
        this.name = "";
        this.teacher = "";
        this.room = "";
        this.hol_course = new HolCourse;
    }
}

export class ClassInfoForEvent {
    name: string;
    room: string;
    teacher: string;
    duration: number;
    lessons: string[];
    
    constructor() {
        this.name = "";
        this.room = "";
        this.teacher = "";
        this.duration = 60;
        this.lessons = [];
    }
}

export class ClassList {
    count: number;
    data: ListClassItem[];

    constructor () {
        this.count = 0;
        this.data = [];
    }
}

export class ListClassItem {
    id: number;
    name: string;
    room: string;
    teacher: string;
    max_number: number;
    total_cost: number;
    cost_per_week: any;
    activities: string;
    suitable_from: string;
    suitable_to: string;
    status: string;
    hol_course_id: number;
    campus_id: number;
    thumbnail_id: string;
    booking_count: number
    hol_course: HolCourse;
}

export class HolCourse {
    id: number;
    name: string;
    type: string;
    school_year: number;
    start_date: string;
    end_date: string;
    description: string;
    status: string
}
export class ClassFilter {
    campus_id: number;
    hol_course_id: number;
    status: any;
    semester_id:any;
    schoolYear: any;
    type: any;
    limit: number;
    page: number;

    constructor() {
        this.campus_id = 0;
        this.hol_course_id = 0;
        this.status = '';
        this.semester_id = 0;
        this.schoolYear = 0;
        this.type = 0;
    }
}


// WEBPACK FOOTER //
// ./src/holiday/models/Class.ts